<template>
    <div id="uploader_layout">
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else>
            <div class="ui inverted dimmer transition visible active" style="display: block !important;">
                <div class="ui text loader">{{ $t('ui.general.initializing') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UploaderLayout",
    data() {
        return {
            is_initialized: false
        }
    },
    computed: {
    },
    created() {
        this.init()
    },
    mounted() {
    },
    methods: {
        async init() {
            console.log(this.$store)
            await this.$store.dispatch('provider/uploader_module/set_urls')
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
    }
}
</script>
<style>
</style>
